function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * PaginationHandler
 * Handles classic prev/next pagination:
 *  - injects the current filter param into pagination links so it is preserved on page change
 *  - wires the page-selector <select> to navigate to the selected page
 */
var PaginationHandler = /*#__PURE__*/function () {
  /**
   * @param {String} [containerSelector='.js-pagination'] - CSS selector for the pagination nav
   */
  function PaginationHandler() {
    var containerSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-pagination';
    _classCallCheck(this, PaginationHandler);
    var pagination = document.querySelector(containerSelector);
    if (pagination) {
      this.updateLinksWithFilter(pagination);
      this.initSelectNavigation(pagination);
    }
  }

  /**
   * Appends the current "filter" query param to every pagination <a> link
   * so that page navigation preserves the active filter.
   *
   * @param {Element} pagination
   */
  return _createClass(PaginationHandler, [{
    key: "updateLinksWithFilter",
    value: function updateLinksWithFilter(pagination) {
      var filterParam = new URL(document.location).searchParams.get('filter');
      if (!filterParam) return;
      pagination.querySelectorAll('a').forEach(function (link) {
        var href = link.getAttribute('href');
        if (href && !href.includes('filter=')) {
          var separator = href.includes('?') ? '&' : '?';
          link.setAttribute('href', "".concat(href).concat(separator, "filter=").concat(filterParam));
        }
      });
    }

    /**
     * Wires the Mozaic pagination <select class="js-selector"> so that
     * changing its value navigates to the corresponding page (preserving filter).
     *
     * @param {Element} pagination
     */
  }, {
    key: "initSelectNavigation",
    value: function initSelectNavigation(pagination) {
      var select = pagination.querySelector('.js-selector');
      if (!select) return;
      select.addEventListener('change', function () {
        var page = select.value;
        if (!/^\d+$/.test(page)) return;
        var filterParam = new URL(document.location).searchParams.get('filter');
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('p', String(page));
        if (filterParam) nextUrl.searchParams.set('filter', filterParam);
        window.location.assign(nextUrl.toString());
      });
    }

    /**
     * Static helper – updates pagination links inside a given container element
     * with a specific filter value (useful after an AJAX content reload).
     *
     * @param {Element} container  - the element that contains the .js-pagination nav
     * @param {String}  filterValue - encoded filter value (may be empty)
     */
  }], [{
    key: "updateContainerPaginationFilter",
    value: function updateContainerPaginationFilter(container, filterValue) {
      if (!filterValue) return;
      var pagination = container.querySelector('.js-pagination');
      if (!pagination) return;
      pagination.querySelectorAll('a').forEach(function (link) {
        var href = link.getAttribute('href');
        if (href && !href.includes('filter=')) {
          var separator = href.includes('?') ? '&' : '?';
          link.setAttribute('href', "".concat(href).concat(separator, "filter=").concat(filterValue));
        }
      });
      var select = pagination.querySelector('.js-selector');
      if (select) {
        var newSelect = select.cloneNode(true);
        select.parentNode.replaceChild(newSelect, select);
        newSelect.addEventListener('change', function () {
          var page = newSelect.value;
          if (!/^\d+$/.test(page)) return;
          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('p', page);
          if (filterValue) nextUrl.searchParams.set('filter', filterValue);
          window.location.assign(nextUrl.toString());
        });
      }
    }
  }]);
}();
export { PaginationHandler as default };